import { type HttpClientConfig } from '../../infra/http/HttpClient'
import { type Chat } from '../domain/Chat'
import { ChatRepository } from '../infra/ChatRepository'
import { createChatHttpClient } from '../infra/createChatHttpClient'

export type GetChatsListRepositoryParams = {
  repository: ChatRepository
}

export async function getChatList(config?: Partial<HttpClientConfig>): Promise<Chat[]> {
  const httpClient = createChatHttpClient()
  const repository = new ChatRepository({ httpClient })

  return repository.getChatList(config)
}
